import { repository } from '@/api/base'
import store from '@/store'
import _ from 'lodash'
import download from '@/plugins/download'

export default {
  async xlsxParse(file, formType) {
    const { data } = await repository.post(`/xlsx/${formType}`, file)
    return data
  },

  async getAllSchedule(filters, page = 0) {
    const { data } = await repository.post(`/xlsxSchedule/findAll/${page}`, filters)
    return data
  },
  async getXlsxSchedule(scheduleId) {
    const { data } = await repository.get(`/xlsxSchedule/${scheduleId}`)
    return data
  },

  async getScheduleById(scheduleId) {
    const { data } = await repository.get(`/xlsx/findById?xlsxScheduleId=${scheduleId}`)
    return data
  },

  async getScheduleStatus() {
    const { data } = await repository.get('/enums/scheduleStatus/findAll')
    return data
  },

  async changeStatus(scheduleId, statusId) {
    const { data } = await repository.put(`/xlsxSchedule/changeStatus/${scheduleId}?statusId=${statusId}`)
    return data
  },

  async save() {
    const formType = store._modules.root.state.schedule.formType
    const file = store._modules.root.state.schedule.fileExel
    const { data } = await repository.post(`/xlsx/save?formType=${formType}`, file)
    return data
  },

  async saveFromInterface(fileName, schedule) {
    const { data } = await repository.post(`/xlsx/saveFromInterface?fileName=${fileName}`, schedule)
    return data
  },

  async updateSchedule(schedule) {
    const newSchedule = _.assign({}, _.omit(schedule, ['xlsxHeaderDto', 'scheduleLessonDtoList', 'statusId']), {
      xlsxHeaderList: schedule.xlsxHeaderDto,
      xlsxLessonList: schedule.scheduleLessonDtoList,
      scheduleStatus: { id: schedule.statusId }
    })

    const { data } = await repository.put('/xlsxSchedule', newSchedule)

    const renameMap = { xlsxHeaderList: 'xlsxHeaderDto', xlsxLessonList: 'scheduleLessonDtoList' }
    return _.reduce(
      renameMap,
      (acc, newKey, oldKey) => ({
        ...acc,
        [newKey]: data[oldKey]
      }),
      _.omit(data, Object.keys(renameMap))
    )
  },

  async remove(scheduleId) {
    await repository.delete(`/xlsxSchedule/${scheduleId}`)
  },

  async getLessonsByFilter(filter) {
    const { data } = await repository.post('/xlsxLesson/findLessonsByGlobalFilter', filter)
    return data
  },

  async createLesson(newData) {
    const { data } = await repository.post('/xlsxLesson', newData)
    return data
  },
  async updateLesson(newData) {
    const { data } = await repository.put('/xlsxLesson', newData)
    return data
  },
  async removeLesson(idList) {
    await repository.post('/xlsxLesson/delete', [...new Set(idList)])
  },
  async copyLessons(payload) {
    const { data } = await repository.post('/xlsxLesson/copy', payload)
    return data
  },

  async moveLessons(payload) {
    const { data } = await repository.post('/xlsxLesson/move', payload)
    return data
  },

  async saveFilterSet(filterSet) {
    const { data } = await repository.post('/pivotFilterSet', filterSet)
    return data
  },

  async getFilterSet() {
    const { data } = await repository.get('/pivotFilterSet/findAllByCurrentUser')
    return data
  },

  async removeFilterSet(id) {
    const { data } = await repository.delete(`/pivotFilterSet/${id}`)
    return data
  },

  async getReportFilterSchedule(filters, reportName) {
    const { data } = await repository.post('/report', filters, { responseType: 'blob' })
    data && download(data, reportName)
  },

  async getTestLessonsByFilter(filters) {
    const { data } = await repository.post('/xlsxLesson/findTestLessonsByGlobalFilter', filters)
    return data
  },

  async findLastDayLessons(filters) {
    const { data } = await repository.post('/xlsxLesson/findLastDayLessons', filters)
    return data
  },

  async createTestLessons(assessmentDate) {
    const { data } = await repository.post('/xlsxLesson/createTestLessons', assessmentDate)
    return data
  },

  async moveLesson (lesson) {
    const { data } = await repository.post(`/xlsxLesson/move`, lesson)
    return data
  },

  async getFilterList (filter) {
    const { data } = await repository.post(`/xlsxLessonFilter/findAll`, filter)
    return data
  }
}
